<div [ngClass]="userLoggedIn !== 'false' ? 'display-cards' :'ab-display-cards'" class="row">
     <div class="col-5 chat-display-card" (click)="selectOption('Trend')">
          <span key="chat-trend">{{'ct.global.msg.chat-trend'| translate}}</span>
     </div>
     <div class="col-5 chat-display-card" (click)="selectOption('Find')">
          <span key="chat-Assistance">{{'ct.global.msg.chat-assistance'| translate}}</span>
     </div>
     <div class="col-5 chat-display-card" *ngIf="userLoggedIn === 'false'" (click)="selectOption('Check')">
          <span key="chat-landing-text1">{{'ct.global.msg.chat-landing-text1'| translate}}</span>
     </div>
     <div class="col-5 chat-display-card" *ngIf="userLoggedIn === 'false'" (click)="selectOption('Reset')">
          <span key="chat-resetPassword">{{'ct.global.msg.chat-resetPassword'| translate}}</span>
     </div>
</div>
